import React, { Component } from "reactn";
import PropTypes from "prop-types";
import Icon from "js/react/components/Icon";

export class RealTimeSearchInput extends Component {
    constructor(props) {
        super(props);
        this.inputRef = React.createRef();
    }

    componentDidMount = () => {
        this.props.focus && this.inputRef.current.focus();
    };

    componentDidUpdate = prevProps => {
        if (prevProps.focus !== this.props.focus) {
            this.props.focus && this.inputRef.current.focus();
        }
    };

    handleTextChange = e => {
        this.handleSearch(e.currentTarget.value);
    };

    handleSearch = rawInput => {
        const { dataSet, onSearch } = this.props;
        if (!dataSet) {
            // if dataSet is not yet loaded, delay searching by 200ms until ready
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                this.handleSearch(rawInput);
            }, 200);
            return;
        }

        let query = rawInput.toLowerCase().trim();
        let results;
        if (query.length === 0) {
            results = null;
        } else {
            results = dataSet.search(query, {
                bool: "AND",
                expand: true
            });
            if (results.length === 0) {
                results = dataSet.search(query, {
                    bool: "OR",
                    expand: true
                });
            }
        }
        onSearch(rawInput, results, query);
    };

    clearSearch = () => {
        this.props.onSearch(null, null, null);
    };

    render() {
        const { searchInput, placeholder } = this.props;

        return (
            <div className="searchbar">
                <i className="micon">search</i>
                <input
                    onChange={e => {
                        this.handleTextChange(e);
                    }}
                    ref={this.inputRef}
                    spellCheck="false"
                    type="text"
                    placeholder={placeholder}
                    value={searchInput || ""}
                />
                {searchInput && <Icon className="clear_search" iconName="cancel" onClick={this.clearSearch} />}
            </div>
        );
    }
}

export default RealTimeSearchInput;
